import { IsNotEmpty, IsString, IsArray, IsOptional } from 'class-validator';

import { Deadline } from './deadline.dto';

export class DeadlineFormDto {
  @IsString()
  @IsNotEmpty()
  group: string;

  @IsString()
  @IsOptional()
  hasDeadline: string;

  @IsArray()
  @IsNotEmpty()
  deadline: Deadline[];
}
